import { TOGGLE_RIBBON } from './constants'

export function toggleRibbon(show = true) {
    return {
        type: TOGGLE_RIBBON,
        data: {
            show,
        },
    }
}
